export default __webpack_public_path__ + "static/CAM-symbol-bw-f62212443249b181ea600353f9563d92.png";